"use strict";
/* globals module */
/**
 * @module commerceLookupsCouponTypeBatchRoute
 * @description Baasic Commerce Lookups CouponType Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Lookups CouponType Batch Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../../common");
;
var contracts_1 = require("../../../../core/contracts");
var CommerceLookupsCouponTypeBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceLookupsCouponTypeBatchRoute, _super);
    function CommerceLookupsCouponTypeBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'commerce/lookups/address-types/batch';
        _this.updateRoute = 'commerce/lookups/address-types/batch';
        _this.deleteRoute = 'commerce/lookups/address-types/batch';
        return _this;
    }
    /**
     * Parses create commerce address type batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsCouponTypeRoute.create();
     */
    CommerceLookupsCouponTypeBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses remove commerce address type batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsCouponTypeRoute.update();
     */
    CommerceLookupsCouponTypeBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses remove commerce address type batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsCouponTypeRoute.remove();
     */
    CommerceLookupsCouponTypeBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CommerceLookupsCouponTypeBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceLookupsCouponTypeBatchRoute);
    return CommerceLookupsCouponTypeBatchRoute;
}(common_1.BaseRoute));
exports.CommerceLookupsCouponTypeBatchRoute = CommerceLookupsCouponTypeBatchRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
